import React from 'react';

interface IIconProps {
  size?: number;
  color?: string;
}

const BestRankIcon = ({ size, color }: IIconProps) => (
  <svg width={size} height={size} viewBox='0 0 47 47' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g opacity='0.1'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M20.0493 2.05045C22.107 0.555451 24.8933 0.55545 26.951 2.05045L43.3143 13.939C45.3719 15.434 46.233 18.084 45.447 20.5029L39.1968 39.7391C38.4108 42.158 36.1567 43.7958 33.6132 43.7958H13.3871C10.8437 43.7958 8.58953 42.158 7.80357 39.7391L1.55337 20.5029C0.767403 18.084 1.62842 15.434 3.68611 13.939L20.0493 2.05045Z'
        fill='#0298F3'
        style={{ mixBlendMode: 'multiply' }}
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.1968 3.17194C22.5686 2.17528 24.4262 2.17528 25.798 3.17194L42.6006 15.3798C43.9724 16.3764 44.5464 18.143 44.0224 19.7557L37.6044 39.5083C37.0804 41.121 35.5776 42.2128 33.882 42.2128H13.1128C11.4172 42.2128 9.91441 41.121 9.39043 39.5083L2.97241 19.7557C2.44843 18.143 3.02244 16.3764 4.39423 15.3798L21.1968 3.17194Z'
      fill='url(#paint0_linear_916_7801)'
      stroke='#FEFFFF'
      strokeOpacity='0.2'
      strokeWidth='0.978487'
    />
    <g mask='url(#mask0_916_7801)'>
      <path
        d='M25.5062 3.56763C24.3058 2.69555 22.6805 2.69555 21.4802 3.56763L4.67757 15.7754C3.47726 16.6475 2.975 18.1933 3.43348 19.6044L9.8515 39.357C10.31 40.7681 11.6249 41.7234 13.1086 41.7234H33.8777C35.3614 41.7234 36.6764 40.7681 37.1348 39.357L43.5529 19.6044C44.0113 18.1933 43.5091 16.6475 42.3088 15.7754L25.5062 3.56763Z'
        stroke='#DEF0F3'
        strokeWidth='0.978487'
        strokeLinecap='round'
      />
    </g>
    <g filter='url(#filter0_d_916_7801)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.3571 9.18631C23.043 8.68798 23.9717 8.68798 24.6576 9.18631L37.2466 18.3327C37.9325 18.8311 38.2195 19.7144 37.9575 20.5207L33.149 35.32C32.887 36.1263 32.1356 36.6722 31.2878 36.6722H15.7269C14.8791 36.6722 14.1277 36.1263 13.8657 35.32L9.05718 20.5207C8.79519 19.7144 9.0822 18.8311 9.76809 18.3327L22.3571 9.18631Z'
        fill='url(#paint1_linear_916_7801)'
      />
      <path
        d='M22.0693 8.79004C22.9266 8.16724 24.088 8.16726 24.9453 8.79004L37.5342 17.9365C38.3915 18.5594 38.7503 19.664 38.4229 20.6719L33.6143 35.4707C33.2868 36.4785 32.3477 37.161 31.2881 37.1611H15.7266C14.667 37.161 13.7278 36.4785 13.4004 35.4707L8.5918 20.6719C8.26434 19.664 8.62311 18.5594 9.48047 17.9365L22.0693 8.79004Z'
        stroke='#94A0A4'
        strokeOpacity='0.06'
        strokeWidth='0.978487'
      />
    </g>
    <g mask='url(#mask1_916_7801)'>
      <g style={{ mixBlendMode: 'multiply' }} opacity='0.2'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.5074 24.0064L7.85156 27.9203V20.0924L23.5074 24.0064ZM23.5074 24.0064L27.4213 8.35059H19.5934L23.5074 24.0064ZM23.5074 24.0064L39.1632 20.0924V27.9203L23.5074 24.0064ZM23.5074 24.0064L31.8101 10.1685L37.3453 15.7036L23.5074 24.0064ZM23.5074 24.0064L31.8101 37.8443L37.3453 32.3091L23.5074 24.0064ZM23.5074 24.0064L19.5934 39.6622H27.4213L23.5074 24.0064ZM23.5074 24.0064L15.2046 37.8443L9.66946 32.3091L23.5074 24.0064Z'
          fill='url(#paint2_linear_916_7801)'
        />
        <path d='M15.2046 10.1685L9.66946 15.7036L23.5074 24.0064L15.2046 10.1685Z' fill='url(#paint3_linear_916_7801)' />
      </g>
      <path d='M21.0659 10.7241C20.3866 11.2177 19.862 11.5988 19.4922 11.8675' stroke='white' strokeWidth='0.978487' strokeLinecap='round' />
    </g>
    <g filter='url(#filter1_d_916_7801)'>
      <path d='M18 23.8225L23.5041 17.7681L29.0082 23.8225L23.5041 29.8768L18 23.8225Z' fill='white' />
      <path
        d='M23.5039 17.0347C23.7105 17.0347 23.9078 17.1212 24.0469 17.2739L29.5508 23.3286C29.8053 23.6085 29.8053 24.036 29.5508 24.3159L24.0469 30.3706C23.9078 30.5235 23.7106 30.6108 23.5039 30.6108C23.2972 30.6108 23.1 30.5236 22.9609 30.3706L17.457 24.3159C17.2026 24.036 17.2026 23.6085 17.457 23.3286L22.9609 17.2739L23.0156 17.2202C23.1493 17.101 23.323 17.0347 23.5039 17.0347Z'
        stroke='white'
        strokeWidth='1.46773'
        strokeLinejoin='round'
      />
    </g>
    <g filter='url(#filter2_i_916_7801)'>
      <path d='M18 23.8225L23.5041 17.7681L29.0082 23.8225L23.5041 29.8768L18 23.8225Z' fill='url(#paint4_linear_916_7801)' />
    </g>
    <g filter='url(#filter3_d_916_7801)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.227 37.2353L17.8882 37.1017C17.681 37.0199 17.5793 36.7857 17.661 36.5785C17.702 36.4746 17.7843 36.3923 17.8882 36.3513L18.227 36.2177C18.6177 36.0637 18.9269 35.7544 19.081 35.3637L19.2146 35.025C19.2963 34.8178 19.5306 34.716 19.7377 34.7978C19.8417 34.8388 19.924 34.921 19.9649 35.025L20.0986 35.3637C20.2526 35.7544 20.5619 36.0637 20.9526 36.2177L21.2913 36.3513C21.4985 36.4331 21.6002 36.6673 21.5185 36.8745C21.4775 36.9784 21.3953 37.0607 21.2913 37.1017L20.9526 37.2353C20.5619 37.3894 20.2526 37.6986 20.0986 38.0893L19.9649 38.4281C19.8832 38.6352 19.649 38.737 19.4418 38.6552C19.3379 38.6143 19.2556 38.532 19.2146 38.4281L19.081 38.0893C18.9269 37.6986 18.6177 37.3894 18.227 37.2353Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter4_d_916_7801)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M35.0084 20.2389L34.5849 20.0719C34.3259 19.9698 34.1988 19.677 34.3009 19.418C34.3522 19.2881 34.455 19.1852 34.5849 19.134L35.0084 18.967C35.4967 18.7744 35.8833 18.3878 36.0759 17.8995L36.2429 17.476C36.345 17.217 36.6378 17.0899 36.8968 17.192C37.0267 17.2433 37.1296 17.3461 37.1808 17.476L37.3478 17.8995C37.5404 18.3878 37.927 18.7744 38.4153 18.967L38.8388 19.134C39.0978 19.2362 39.2249 19.5289 39.1228 19.7879C39.0715 19.9178 38.9687 20.0207 38.8388 20.0719L38.4153 20.2389C37.927 20.4315 37.5404 20.8181 37.3478 21.3064L37.1808 21.7299C37.0786 21.9889 36.7859 22.116 36.5269 22.0139C36.397 21.9626 36.2941 21.8598 36.2429 21.7299L36.0759 21.3064C35.8833 20.8181 35.4967 20.4315 35.0084 20.2389Z'
        fill='white'
      />
    </g>
    <g filter='url(#filter5_d_916_7801)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.2269 24.8771L10.9728 24.7769C10.8174 24.7156 10.7411 24.54 10.8024 24.3846C10.8332 24.3066 10.8949 24.2449 10.9728 24.2142L11.2269 24.114C11.5199 23.9984 11.7518 23.7665 11.8674 23.4735L11.9676 23.2194C12.0289 23.064 12.2046 22.9877 12.36 23.049C12.4379 23.0797 12.4996 23.1415 12.5304 23.2194L12.6306 23.4735C12.7461 23.7665 12.9781 23.9984 13.2711 24.114L13.5251 24.2142C13.6805 24.2755 13.7568 24.4511 13.6955 24.6065C13.6648 24.6845 13.6031 24.7462 13.5251 24.7769L13.2711 24.8771C12.9781 24.9927 12.7461 25.2246 12.6306 25.5176L12.5304 25.7717C12.4691 25.9271 12.2934 26.0034 12.138 25.9421C12.0601 25.9114 11.9984 25.8497 11.9676 25.7717L11.8674 25.5176C11.7518 25.2246 11.5199 24.9927 11.2269 24.8771Z'
        fill='white'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_916_7801'
        x='6.02545'
        y='6.8555'
        width='34.9638'
        height='33.7308'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
        <feOffset dy='0.978487' />
        <feGaussianBlur stdDeviation='0.978487' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.0196078 0 0 0 0 0.443137 0 0 0 0 0.643137 0 0 0 0.12 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_916_7801' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_916_7801' result='shape' />
      </filter>
      <filter
        id='filter1_d_916_7801'
        x='15.7984'
        y='15.9334'
        width='15.4111'
        height='16.5122'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
        <feOffset dy='0.366933' />
        <feGaussianBlur stdDeviation='0.366933' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.19669 0 0 0 0 0.27695 0 0 0 0 0.483333 0 0 0 0.2 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_916_7801' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_916_7801' result='shape' />
      </filter>
      <filter
        id='filter2_i_916_7801'
        x='18'
        y='17.7681'
        width='11.0078'
        height='12.4758'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
        <feOffset dy='0.366933' />
        <feGaussianBlur stdDeviation='0.183466' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.670588 0 0 0 0 0.760784 0 0 0 0 0.780392 0 0 0 1 0' />
        <feBlend mode='normal' in2='shape' result='effect1_innerShadow_916_7801' />
      </filter>
      <filter
        id='filter3_d_916_7801'
        x='15.6758'
        y='32.8126'
        width='7.82801'
        height='7.82801'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
        <feOffset />
        <feGaussianBlur stdDeviation='0.978487' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.705882 0 0 0 0 0.823529 0 0 0 0 0.831373 0 0 0 1 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_916_7801' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_916_7801' result='shape' />
      </filter>
      <filter
        id='filter4_d_916_7801'
        x='32.3087'
        y='15.1998'
        width='8.80653'
        height='8.80653'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
        <feOffset />
        <feGaussianBlur stdDeviation='0.978487' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.705882 0 0 0 0 0.823529 0 0 0 0 0.831373 0 0 0 1 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_916_7801' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_916_7801' result='shape' />
      </filter>
      <filter
        id='filter5_d_916_7801'
        x='8.82428'
        y='21.0709'
        width='6.8495'
        height='6.8495'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
        <feOffset />
        <feGaussianBlur stdDeviation='0.978487' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.705882 0 0 0 0 0.823529 0 0 0 0 0.831373 0 0 0 1 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_916_7801' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_916_7801' result='shape' />
      </filter>
      <linearGradient id='paint0_linear_916_7801' x1='0.992188' y1='1.50049' x2='0.992188' y2='46.5109' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#C4ECEB' />
        <stop offset='1' stopColor='#A7BCC1' />
      </linearGradient>
      <linearGradient id='paint1_linear_916_7801' x1='7.85156' y1='8.35059' x2='7.85156' y2='39.6622' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#F0FBFE' />
        <stop offset='1' stopColor='#C0DCDC' />
      </linearGradient>
      <linearGradient id='paint2_linear_916_7801' x1='9.29941' y1='8.35059' x2='9.29941' y2='36.7665' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#AFD4D6' />
        <stop offset='1' stopColor='#B9D9DB' stopOpacity='0.57' />
      </linearGradient>
      <linearGradient id='paint3_linear_916_7801' x1='9.29941' y1='8.35059' x2='9.29941' y2='36.7665' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#AFD4D6' />
        <stop offset='1' stopColor='#B9D9DB' stopOpacity='0.57' />
      </linearGradient>
      <linearGradient id='paint4_linear_916_7801' x1='18' y1='17.7681' x2='18' y2='29.8768' gradientUnits='userSpaceOnUse'>
        <stop stopColor='#ADC9CD' />
        <stop offset='1' stopColor='#A8C4C8' />
      </linearGradient>
      <mask id='mask0_916_7801' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='2' y='1' width='43' height='42'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.1968 3.17194C22.5686 2.17528 24.4262 2.17528 25.798 3.17194L42.6006 15.3798C43.9724 16.3764 44.5464 18.143 44.0224 19.7557L37.6044 39.5083C37.0804 41.121 35.5776 42.2128 33.882 42.2128H13.1128C11.4172 42.2128 9.91441 41.121 9.39043 39.5083L2.97241 19.7557C2.44843 18.143 3.02244 16.3764 4.39423 15.3798L21.1968 3.17194Z'
          fill='white'
          stroke='white'
          strokeWidth='0.978487'
        />
      </mask>
      <mask id='mask1_916_7801' style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='8' y='8' width='31' height='29'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.3571 9.18631C23.043 8.68798 23.9717 8.68798 24.6576 9.18631L37.2466 18.3327C37.9325 18.8311 38.2195 19.7144 37.9575 20.5207L33.149 35.32C32.887 36.1263 32.1356 36.6722 31.2878 36.6722H15.7269C14.8791 36.6722 14.1277 36.1263 13.8657 35.32L9.05718 20.5207C8.79519 19.7144 9.0822 18.8311 9.76809 18.3327L22.3571 9.18631Z'
          fill='white'
        />
      </mask>
    </defs>
  </svg>
);

BestRankIcon.defaultProps = {
  size: 46,
  color: 'currentColor',
};

export default BestRankIcon;
